<template>
  <div class="reportTable">
    <!-- F31 -->
    <section ref="print">
      <div class="mytitle">
        <ul>
          <li>
            <span>打印日期：</span>
            <span>{{ nowday }}</span>
          </li>
          <li>
            <span>打印时间：</span>
            <span>{{ nowtime }}</span>
          </li>
          <li>
            <span>酒店日期：</span>
            <span>{{ $parent.hotelInfo.dhoteltime }}</span>
          </li>
        </ul>
        <ul style="display: flex; flex-direction: column; align-items: center">
          <li>
            <span></span>
            <span>{{ $parent.hotelInfo.cname }}</span>
          </li>
          <li>
            <span></span>
            <span>{{ $parent.bbmc }}</span>
          </li>
          <li>
            <span>查询日期：</span>
            <span>{{ this.$moment(this.startDate).format('YYYY-MM-DD') }}</span>
            <span v-if="$parent.endTimeShow"
              >至{{ this.$moment(this.endDate).format('YYYY-MM-DD') }}</span
            >
          </li>
        </ul>
        <ul
          style="display: flex; flex-direction: column; align-items: flex-end"
        >
          <li>
            <span>操作员:</span>
            <span>{{ $parent.userInfo.cname }}</span>
          </li>
          <!-- <li>
            <span>总页数:</span>
            <span>{{pagecount}}</span>
          </li>-->
          <li v-if="$parent.datacount > 0">
            <span>总条数:</span>
            <span>{{ $parent.datacount }}条</span>
          </li>
        </ul>
      </div>
      <div class="report">
        <div style="font-weight:bold">收银员合计列表</div>
        <div class="PreArrivalItem" style="font-weight:bold">
          <!-- <th>账项(中文)</th> -->
          <span>账项名称</span>
          <span style="text-align:right">1.定金</span>
          <span>定金数量</span>
          <span style="text-align:right">2.结帐款</span>
          <span>结帐款数量</span>
          <span style="text-align:right">3.缴款</span>
          <!-- <span>3.缴款合计</span> -->
        </div>

        <template v-for="totalItem in preArrivalList.totalList">
          <!-- <div v-for="groupItem in preArrivalList.groupList" class="totalItem"> -->
          <div class="PreArrivalItem">
            <span>{{ totalItem.txnItemName }}</span>

            <span style="text-align:right">{{
              totalItem.earnest.toFixed(2)
            }}</span>

            <span>{{ totalItem.earnestCount }}</span>
            <span style="text-align:right">
              {{ totalItem.settleAmount.toFixed(2) }}
            </span>

            <span>{{ totalItem.settleCount }}</span>
            <span style="text-align:right">{{
              totalItem.collectAmount.toFixed(2)
            }}</span>
            <!-- </div> -->
          </div>
        </template>
        <div class="PreArrivalItem" style="font-weight:bold">
          <span>合计:</span>
          <span style="text-align:right">{{
            $parent.curreny(totalAmount)
          }}</span>
          <span>{{ totalCount }}</span>
          <span style="text-align:right">{{
            $parent.curreny(settleAmount)
          }}</span>
          <span>{{ settleCount }}</span>
          <span style="text-align:right">{{
            $parent.curreny(collectAmount)
          }}</span>
        </div>
        <div style="border-top:2px solid black;margin-top:6px;font-weight:bold">
          收银员分类列表
        </div>
        <template v-for="groupItem in preArrivalList.groupList">
          <div v-for="txnItem in groupItem.txnItemList" class="PreArrivalItem">
            <span>{{ txnItem.txnItemName }}</span>

            <span style="text-align:right">{{
              txnItem.earnest.toFixed(2)
            }}</span>

            <span>{{ txnItem.earnestCount }}</span>

            <span style="text-align:right">{{
              txnItem.settleAmount.toFixed(2)
            }}</span>

            <span>{{ txnItem.settleCount }}</span>
            <span style="text-align:right">{{
              txnItem.collectAmount.toFixed(2)
            }}</span>
            <!-- </div> -->
          </div>
          <div class="collectAmount">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div>
              <span>操作员:</span>
              <span>{{ groupItem.userName }}</span>
            </div>
            <div style="text-align:right">
              <span>合计:</span>
              <span>{{ groupItem.collectAmount.toFixed(2) }}</span>
            </div>
          </div>
        </template>
        <div class="PreArrivalItem" style="font-weight:bold">
          <span>合计:</span>
          <span style="text-align:right">{{
            $parent.curreny(groupAmount)
          }}</span>

          <span>{{ groupCount }}</span>
          <span style="text-align:right">{{ $parent.curreny(jzAmount) }}</span>

          <span>{{ jzCount }}</span>

          <span style="text-align:right">{{ $parent.curreny(jkAmount) }}</span>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { postRequest, getRequest } from '@/api/api1.js'
export default {
  data() {
    return {
      // 未处理数据
      preArrivalList: [],
      // 记录
      record: 0,
      room: 0,
      total: 0,
      allPage: 0,
      userName: localStorage.getItem('cname'),

      tableUserName: '',
      tableUserList: [],
      // 筛选数据
      allTableData: [],
      queryDate: '',
      totalAmount: 0,
      totalCount: 0,
      settleAmount: 0,
      settleCount: 0,
      collectAmount: 0,
      // 收银员分类列表合计
      groupAmount: 0,
      groupCount: 0,
      jzAmount: 0,
      jzCount: 0,
      jkAmount: 0,
      nowday: '',
      nowtime: '',
      startDate: '',
      endDate: '',
    }
  },
  created() {
    this.$parent.bbmc = 'U99.全天收银员区间缴款报表'
    this.$parent.startDate = this.$moment(new Date()).format('YYYY-MM-DD')
    this.$parent.endDate = this.$moment(new Date()).format('YYYY-MM-DD')
    this.queryDate = new Date()
    this.getPreArrivalList()
    this.$parent.startTimeShow = true
    this.$parent.endTimeShow = true
    this.$parent.chaxunvib = true
    //  this.$parent.closeshow();
    // this.$parent.isShow2 = false;
    //
  },
  methods: {
    dodayin() {
      this.$print(this.$refs.print)
    },
    getPreArrivalList() {
      this.totalAmount = 0
      this.totalCount = 0
      this.settleAmount = 0
      this.settleCount = 0
      this.collectAmount = 0
      this.groupAmount = 0
      this.groupCount = 0
      this.jzAmount = 0
      this.jzCount = 0
      this.jkAmount = 0
      getRequest('/report/U99', {
        startTime: this.$parent.startDate,
        endTime: this.$parent.endDate,
      }).then(res => {
        if (res.status != 200)
          return vm.$mymessage({
            content: res.code,
            type: 'error',
            time: 3000,
            hasClose: true,
          })
        this.preArrivalList = res.data
        let list = []
        this.$store.state.preArrivalName = 'U99.全天收银员区间缴款报表'

        list = JSON.parse(JSON.stringify(res.data.totalList))

        res.data.groupList.forEach(groupItem => {
          groupItem.txnItemList.forEach(txnItem => {
            list.push({
              txnItem2: txnItem.txnItem,
              txnItemName2: txnItem.txnItemName,
              earnest2: txnItem.earnest,
              earnestCount2: txnItem.earnestCount,
              settleAmount2: txnItem.settleAmount,
              settleCount2: txnItem.settleCount,
              userName2: groupItem.userName,
            })
          })
        })

        // list.forEach(listItem => {
        //   res.data.groupList.forEach(groupItem => {
        //     groupItem.txnItemList.forEach(txnItem => {
        //       listItem.txnItem2 = txnItem.txnItem
        //       listItem.txnItemName2 = txnItem.txnItemName
        //       listItem.earnest2 = txnItem.earnest
        //       listItem.earnestCount2 = txnItem.earnestCount
        //       listItem.settleAmount2 = txnItem.settleAmount
        //       listItem.settleCount2 = txnItem.settleCount
        //     })
        //   })
        // })

        console.log('list', list)

        this.$store.state.preArrivalList = list
        let earnest1 = 0
        let earnest2 = 0
        res.data.totalList.forEach(totalItem => {
          this.totalAmount += totalItem.earnest
          this.totalCount += totalItem.earnestCount
          this.settleAmount += totalItem.settleAmount
          this.settleCount += totalItem.settleCount
          this.collectAmount += totalItem.collectAmount
        })
        res.data.groupList.forEach(groupItem => {
          // earnest2 += group.earnest;
          groupItem.txnItemList.forEach(txnItem => {
            this.groupAmount += txnItem.earnest
            this.groupCount += txnItem.earnestCount
            this.jzAmount += txnItem.settleAmount
            this.jzCount += txnItem.settleCount
            this.jkAmount += txnItem.collectAmount
          })
        })
        this.earnest = earnest1 + earnest2

        let allList = res.data.groupList.concat(res.data.totalList)

        this.tableUserList = Array.from(
          new Set(allList.map(item => item.operator))
        )
        if (!this.tableUserList.length) this.tableUserName = ''
        this.selectUserName()
        this.$forceUpdate()
        this.nowday = this.$moment(new Date()).format('YYYY-MM-DD')
        this.nowtime = this.$moment(new Date()).format('HH:mm:ss')
        this.startDate = this.$parent.startDate
        this.endDate = this.$parent.endDate
      })
    },
    doserach() {
      this.getPreArrivalList()
    },
    // 根据操作员筛选
    selectUserName() {
      let allTableData = this.preArrivalList

      if (!this.tableUserName)
        return (() => {
          this.allTableData = allTableData
          this.record = this.allTableData.length
          this.allPage = Math.ceil(this.allTableData.length / 10)
        })()
      this.allTableData = allTableData.filter(item => {
        return item.operator == this.tableUserName
      })
      this.record = this.allTableData.length
      this.allPage = Math.ceil(this.allTableData.length / 10)
    },
  },
  // watch: {
  //   startDate: {
  //     handler(n, o) {
  //       this.getPreArrivalList()
  //     },
  //   },
  //   endDate: {
  //     handler(n, o) {
  //       this.getPreArrivalList()
  //     },
  //   },
  // },
}
</script>
<style scoped>
.collectAmount {
  display: flex;
  font-weight: bold;
  justify-content: flex-end;
  font-size: 14px;
  border-bottom: 1px dotted black;
}
.collectAmount > div {
  /* width:220px; */
  flex: 1;
  text-align: center;
}
.collectAmount > div:nth-child(1) {
  margin-right: 20px;
}
.collectAmount > div:nth-child(2) {
  text-align: right;
}
.PreArrivalItem span {
  font-size: 14px;
  flex: 1;
  text-align: center;
}
</style>
